import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate } from '@angular/router';

import { NavigationService, ProductHomepagesConfig } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class GameclientPrebuyGuardService implements CanActivate {
    global: any;
    constructor(
        private activeRoute: ActivatedRoute,
        private productHomepagesConfig: ProductHomepagesConfig,
        private navigator: NavigationService,
    ) {}

    canActivate(): boolean {
        if (this.activeRoute.snapshot.queryParamMap.get('hideHeader') == 'true') {
            return true;
        } else {
            let apiUrl: string = '';
            apiUrl = this.productHomepagesConfig.bingo + '/bingo/rooms';
            this.navigator.goTo(apiUrl);
            return false;
        }
    }
}
